import { UploadFileUserPayload } from 'app/api/user'
import { getFormData } from 'app/utils/formUtils'
import { fileValidation } from 'app/utils/validationUtils'
import * as Yup from 'yup'
export type InputRegistryDocumentFormData = {
  input_registry?: FileList | null
}

export const inputRegistryDefaultValues: InputRegistryDocumentFormData = {
  input_registry: null,
}

export const inputRegistryValidationSchema = Yup.object().shape({
  input_registry: fileValidation({
    isRequired: true,
  }),
})

export const adaptFormDataToAPI = (
  formData: InputRegistryDocumentFormData
): FormData => {
  const data: UploadFileUserPayload = {
    file: formData.input_registry as FileList,
    type: 'pdf_registry',
  }
  return getFormData({ formData: data })
}
